export default __webpack_public_path__ + "static/media/Logo White.c909b351.svg";